module.exports = __webpack_public_path__ + "img/unlocked_icon.4211735d.svg";